// src/components/BlinkingCursor.js
import React from 'react';

const BlinkingCursor = React.memo(() => {
  return <span className="blinking-cursor" />;
});

export default BlinkingCursor;